export default "__VITE_ASSET__BqnacQu5__"